import React from "react";
import { Spinner } from "reactstrap";
import "assets/css/loading.css";

class LoadingBox extends React.Component {
  render() {
    return (
      <div className="boxloadingmap">
          <div className="loadingmap"> <div className="txtlmp">Carregando... </div> <Spinner /></div> 
      </div>
    );
  }
}


export default LoadingBox;
